import { z } from "zod";

export const MemorySchema = z.object({
  id: z.string(),
  memory: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  user_id: z.string(),
  metadata: z
    .object({
      datamate_id: z.string().optional(),
      datamate_name: z.string().optional(),
      confidence: z.number().optional(),
      memory_type: z.string().optional(),
      title: z.string().optional(),
    })
    .nullable(),
  categories: z.array(z.string()).nullish(),
});

export type Memory = z.infer<typeof MemorySchema>;

export const MemoryResponseSchema = z.object({
  message: z.string(),
});

export type MemoryResponse = z.infer<typeof MemoryResponseSchema>;
